export const headerStyles = {
  root: 'bg-brand-950 text-brand-100 shadow-md',
  topBar:
    'mx-auto flex min-h-16 w-full max-w-7xl flex-nowrap items-center gap-3 px-4 sm:min-h-[4.5rem] sm:px-6 lg:px-8',
  brand: 'flex shrink-0 items-center gap-2',
  logo: 'h-8 w-auto object-contain sm:h-9 lg:h-10',
  brandText: 'sr-only',
  searchWrap: 'mx-2 hidden min-w-0 flex-1 md:block',
  searchWrapMobile: 'border-t border-brand-900 bg-brand-950 px-4 py-2 md:hidden',
  searchPanel:
    'absolute left-0 right-0 top-full z-50 mt-2 max-h-[70vh] overflow-auto rounded-lg border border-brand-700/20 bg-surface py-2 text-brand-950 shadow-xl',
  searchDirect:
    'flex w-full items-center px-4 py-3 text-left font-sans text-sm font-semibold text-brand-950 hover:bg-brand-100',
  searchStatus: 'px-4 py-3 font-sans text-sm text-brand-700',
  searchSuggestion:
    'flex w-full flex-col gap-0.5 px-4 py-2.5 text-left transition-colors hover:bg-brand-100',
  actions: 'ml-auto flex shrink-0 flex-nowrap items-center justify-end gap-1 sm:gap-2',
  actionLink:
    'inline-flex h-10 min-h-10 shrink-0 items-center justify-center gap-2 rounded-md px-2 text-brand-100/90 transition-colors hover:bg-brand-900 hover:text-brand-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400 lg:w-auto lg:px-3',
  actionLinkActive: 'bg-brand-900 text-brand-400',
  navBar: 'border-t border-brand-900 bg-black',
  navInner:
    'mx-auto flex min-h-12 w-full max-w-7xl items-center gap-1 overflow-x-auto px-4 sm:px-6 md:overflow-visible lg:px-8',
  link: 'inline-flex min-h-10 shrink-0 items-center whitespace-nowrap rounded-md px-3 py-2 font-sans text-sm font-semibold text-brand-100/95 transition-colors hover:bg-brand-900 hover:text-brand-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400',
  linkActive: 'bg-brand-900 text-brand-400',
  navDropdown:
    'absolute left-0 top-full z-50 mt-1 min-w-48 overflow-hidden rounded-md border border-brand-700/20 bg-surface py-1 text-brand-950 shadow-lg',
  navDropdownLink:
    'block px-3 py-2.5 font-sans text-sm font-semibold text-brand-800 hover:bg-brand-100 hover:text-brand-950',
  navDropdownLinkActive: 'bg-brand-100 text-brand-950',
  mobileMenu: 'sm:hidden',
  drawer:
    'absolute left-0 right-0 top-full z-40 border-b border-brand-900 bg-brand-950 px-4 py-3 shadow-lg sm:hidden',
  drawerLink:
    'block rounded-md px-3 py-2.5 font-sans text-sm font-medium text-brand-100/90 hover:bg-brand-900 hover:text-brand-400',
  drawerLinkActive: 'bg-brand-900 text-brand-400',
} as const;
